import { render, staticRenderFns } from "./CustomerEmailAddressEditor.vue?vue&type=template&id=e661e1ac&scoped=true"
import script from "./CustomerEmailAddressEditor.vue?vue&type=script&lang=js"
export * from "./CustomerEmailAddressEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e661e1ac",
  null
  
)

export default component.exports